import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './meeting-templates.types';

export const meetingTemplatesSelectors = {
  ...generateResourceSelectors<types.IMeetingTemplate>((state) => state.resource.meetingTemplates),
};
